const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogUnidadeTematica(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogUnidadeTematica`, params);
    },
    $obterRelatorioLogCSVUnidadeTematica(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogUnidadeTematicaCsv`, params);
    },
    $obterRelatorioLogPDFUnidadeTematica(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogUnidadeTematicaPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
